import { useMemo } from 'react';

import { useProfile } from '@mint-lib/profile-helpers';
import { enGB, enUS, it, ptBR, type Locale } from 'date-fns/locale';

const localeMap = new Map([
  ['en-GB', enGB],
  ['en-US', enUS],
  ['it-IT', it],
  ['pt-BR', ptBR],
]);

export const useDateLocalize = () => {
  const { getProfileField } = useProfile();

  const locale = getProfileField('locale') || 'en-GB';

  const dateFormat = getProfileField('formattingConfig')?.datesFormat || locale;

  const localize = useMemo(
    () =>
      ({
        ...localeMap.get(locale),
        options: localeMap.get(dateFormat)?.options,
        formatLong: localeMap.get(dateFormat)?.formatLong,
      }) as Locale,
    [dateFormat, locale],
  );

  return localize;
};
